<template>
	<div class="main">
    <div class="mb-30 slider-big" style="margin-top: -20px">
      <div id="carousel-slider-big" class="carousel slide" data-ride="carousel">
      <!-- Indicators -->
        <ol class="carousel-indicators">
          <li data-target="#carousel-slider-big" data-slide-to="0" class="active"></li>
          <li data-target="#carousel-slider-big" data-slide-to="1" class=""></li>
        </ol>
        <!-- Wrapper for slides -->
        <div class="carousel-inner" role="listbox">
          <div class="item active">
            <div class="slider-wrapper">
              <a href="#"><img class="img-responsive" src="~assets/img/slide-big1.jpg"></a>
            </div><!-- .slider-wrapper -->
          </div><!-- .item  -->
          <div class="item">
            <div class="slider-wrapper">
              <a href="#"><img class="img-responsive" src="~assets/img/slide-big2.jpg"></a>
            </div><!-- .slider-wrapper -->
          </div><!-- .item  -->
        </div><!-- .carousel-inner -->
        <!-- Controls -->
        <!--
        <a class="left carousel-control" href="#carousel-slider" role="button" data-slide="prev">
        <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
        </a>
        <a class="right carousel-control" href="#carousel-slider" role="button" data-slide="next">
        <span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
        </a>
        -->
      </div><!-- #carousel-slider -->
    </div>
		<!-- BIG SLOGAN-->
		<div class="container">
			<p class="crowd-or-rais">
				<router-link to="/crowdfunding" class="crowd-or">CROWDFUNDING</router-link>
				<span class="or">or</span>
				<router-link to="/fundraising" class="rais-or">FUNDRAISING?</router-link>
			</p>
			<h1 class="big-slogan-blue">{{ $t("main.header") }}</h1>
			<h2 class="mb-50">{{ $t("main.subtitle") }}</h2>
		</div>

    <slider v-if="promotedProjects.length" :projects='promotedProjects'></slider>

		<!-- CROWDFUNDING LISTING-->
		<div class="container">
      <project-tabs :crowdfunding="true" :projects="crowd"></project-tabs>

			<!-- CROWDFUNDING ALL CATEGORIES-->
			<div class="mb-30">
				<div class="all-categories"><strong>CROWDFUNDING:</strong> {{ $t("main.allCategories") }}</div>
        <div class="all-categories-list-crowd">
          <ul class="list-inline">
            <li v-for="category in crowdCategories">
              <router-link :to="{ name: 'crowdfunding', query: { category_id: category.id, category: category.name } }">{{ category.name }}</router-link>
            </li>
          </ul>
        </div><!-- .all-categories-list-crowd -->
			</div>
		</div>
		<!-- FUNDRAISING HOME BOX-->
		<div class="container-fluid domore-yellow-light-bgd">
			<div class="container fundraising-home-box">
				<p class="fundraising-home-box-title domore-yellow">FUNDRAISING</p>
				<h1>{{ $t("main.fundraisingTitle") }}</h1>
				<h2>{{ $t("main.fundraisingSubtitle") }}</h2>
			</div>
		</div>
		<!-- FUNDRAISING LISTING-->
		<div class="container">
      <project-tabs :crowdfunding="false" :projects="fundraising"></project-tabs>

  		<!-- FUNDRAISING ALL CATEGORIES-->
  		<div class="mb-50">
  			<div class="all-categories"><strong>FUNDRAISING:</strong> {{ $t("main.allCategories") }}</div>
  			<div class="all-categories-list-rais">
  				<ul class="list-inline">
            <li v-for="category in raisCategories">
              <router-link :to="{ name: 'fundraising', query: { category_id: category.id, category: category.name } }">{{ category.name }}</router-link>
            </li>
  				</ul>
  			</div>
  		</div>
    </div>

		<!-- WHY DO MORE?-->
		<why-do-more></why-do-more>
		<partners></partners>

	</div>
</template>

<script>
// API
import projectsApi from '@/api/v1/projects';
// Components
import CrowdfundingTile from '@/components/Project/Tiles/Crowdfunding';
import FundraisingTile from '@/components/Project/Tiles/Fundraising';
import ProjectTabs from '@/components/Main/Tabs';
import Slider from '@/components/Project/Slider/Index';
import WhyDoMore from '@/components/WhyDoMore';
import Partners from '@/components/Partners';

export default {
  components: { CrowdfundingTile, FundraisingTile, WhyDoMore, Partners, Slider, ProjectTabs },
  data() {
    return {
      tileSize: 'col-md-6',
      promotedProjects: [],
      crowdCategories: [],
      raisCategories: [],
      crowd: {
        popular: [],
        ending: [],
        littleMissing: [],
      },
      fundraising: {
        popular: [],
        ending: [],
        littleMissing: [],
      },
    };
  },
  created() {
    projectsApi.getCategories((categories) => { this.crowdCategories = categories; }, true);
    projectsApi.getCategories((categories) => { this.raisCategories = categories; }, false);
    projectsApi.getPromotedProjects((projects) => { this.promotedProjects = projects; });
    projectsApi.getMainPageProjects(true, 4, (projects) => {
      this.crowd.popular = projects.popular;
      this.crowd.littleMissing = projects.little_missing;
      this.crowd.ending = projects.almost_ended;
    });
    projectsApi.getMainPageProjects(false, 3, (projects) => {
      this.fundraising.popular = projects.popular;
      this.fundraising.littleMissing = projects.little_missing;
      this.fundraising.ending = projects.almost_ended;
    });
  },
};
</script>



// WEBPACK FOOTER //
// Main.vue?22d6d9ac